<template>
  <div class="flex flex-direction" id="sandbox">
    <div id="sandbox-pc">
      <div class="top">
        <Title :ch="'沙箱实验室'"></Title>
      </div>
      <div class="describe1">
        提供丰富的实践场景和真实的线上编码实操环境，了解云上应用开发实战，Talk
        is cheap, show me the code。
      </div>
      <div class="content">
        <div
          class="main"
          :style="{ background: hoverIndex == 1 ? '#ffffff' : '' }"
          @mouseenter="hoverIndex = 1"
        >
          <img v-if="hoverIndex === 1" class="topImg" :src="blueImgTop" />
          <div
            class="text cs"
            @click.stop="
              linkDownload(
                'https://lab.huaweicloud.com/testdetail_236',
                '30分钟轻松搭建网站应用'
              )
            "
          >
            <div
              class="title"
              :style="{ color: hoverIndex === 1 ? '#B4251E' : '#151E26' }"
            >
              30分钟轻松搭建网站应用
            </div>
            <div
              class="describe"
              :style="{ color: hoverIndex === 1 ? '#151E26' : '#888888' }"
            >
              快速入门云计算，利用云服务搭建WordPress网站。
            </div>
            <div class="more flex align-center cs">
              <span>立即实验</span>
              <img :src="rightArrow" />
            </div>
          </div>
          <img class="blueImg" :src="blueImg" />
        </div>
        <div class="secondary flex align-center justify-between">
          <div
            class="secondary_left"
            :style="{ background: hoverIndex == 2 ? '#ffffff' : '' }"
            @mouseenter="hoverIndex = 2"
          >
            <img v-if="hoverIndex === 2" class="topImg" :src="redImgTop" />
            <div
              class="text cs"
              @click.stop="
                linkDownload(
                  'https://lab.huaweicloud.com/testdetail_287',
                  '使用ModelArts实现花卉图像分类'
                )
              "
            >
              <div
                class="title"
                :style="{ color: hoverIndex === 2 ? '#B4251E' : '#151E26' }"
              >
                使用ModelArts实现花卉图像分类
              </div>
              <div
                class="describe_l"
                :style="{ color: hoverIndex === 2 ? '#151E26' : '#888888' }"
              >
                零基础体验AI开发，快速构建花卉图像分类。
              </div>
              <div class="more flex align-center cs">
                <span>立即实验</span>
                <img :src="rightArrow" />
              </div>
            </div>
            <img class="yellowImg" :src="yellowImg" />
          </div>
          <div
            class="secondary_right"
            :style="{ background: hoverIndex == 3 ? '#ffffff' : '' }"
            @mouseenter="hoverIndex = 3"
          >
            <img v-if="hoverIndex === 3" class="topImg" :src="yellowImgTop" />
            <div
              class="text cs"
              @click.stop="
                linkDownload(
                  'https://lab.huaweicloud.com/testdetail_290',
                  'MySQL本地数据库迁移'
                )
              "
            >
              <div
                class="title"
                :style="{ color: hoverIndex === 3 ? '#B4251E' : '#151E26' }"
              >
                MySQL本地数据库迁移
              </div>
              <div
                class="describe_l"
                :style="{ color: hoverIndex === 3 ? '#151E26' : '#888888' }"
              >
                通过DRS掌握迁移流程，实现迁移中不停机最小化中断时间。
              </div>
              <div class="more flex align-center cs">
                <span>立即实验</span>
                <img :src="rightArrow" />
              </div>
            </div>
            <img class="redImg" :src="redImg" />
          </div>
        </div>
      </div>
      <DidLink
        @click.native="linkMore('https://lab.huaweicloud.com/')"
      ></DidLink>
    </div>
    <div id="sandbox-wap">
      <div class="top">
        <Title :ch="'沙箱实验室'" :bg-img="titleBgImg"></Title>
      </div>
      <div class="describe">
        提供丰富的实践场景和真实的线上编码实操环境，了解云上应用开发实战，Talk
        is cheap, show me the code。
      </div>
      <div class="list flex">
        <div
          class="swiper-container-sand flex"
          style="
            width: 100%;
            height: 100%;
            transform: translate3d(0, 0, 0);
            overflow: hidden;
          "
        >
          <!--          <swiper-->
          <!--            :options="swiperOption"-->
          <!--            class="swiper-wrapper flex"-->
          <!--            style="width: 100%; height: calc(100% - 30px)"-->
          <!--          >-->
          <!--            <swiper-slide-->
          <!--              class="swiper-slide flex"-->
          <!--              style="width: 100%; height: 100%"-->
          <!--              v-for="(sand, index) in sandboxLists"-->
          <!--              :key="index"-->
          <!--            >-->
          <!--              <a @click="toDetail(sand.url, sand.title)" v-if="isLowIos">-->
          <!--                <div class="slide" style="width: 100%">-->
          <!--                  <div class="title">{{ sand.title }}</div>-->
          <!--                  <div class="desc">{{ sand.desc }}</div>-->
          <!--                  <div class="more flex align-center justify-start cs">-->
          <!--                    <span>立即实验</span>-->
          <!--                    <img :src="rightArrow" />-->
          <!--                  </div>-->
          <!--                  <img class="bgImg" :src="sand.img" />-->
          <!--                </div>-->
          <!--              </a>-->
          <!--              <div v-else class="slide" style="width: 100%">-->
          <!--                <div class="title">{{ sand.title }}</div>-->
          <!--                <div class="desc">{{ sand.desc }}</div>-->
          <!--                <div class="more flex align-center justify-start cs">-->
          <!--                  <span>立即实验</span>-->
          <!--                  <img :src="rightArrow" />-->
          <!--                </div>-->
          <!--                <img class="bgImg" :src="sand.img" />-->
          <!--              </div>-->
          <!--            </swiper-slide>-->
          <!--          </swiper>-->
          <div
            class="swiper-wrapper flex"
            style="width: 100%; height: calc(100% - 30px)"
          >
            <div
              class="swiper-slide flex"
              style="width: 100%; height: 100%"
              v-for="(sand, index) in sandboxLists"
              :key="index"
            >
              <div class="slide" style="width: 100%">
                <div class="title">{{ sand.title }}</div>
                <div class="desc">{{ sand.desc }}</div>
                <div class="more flex align-center justify-start cs">
                  <span>立即实验</span>
                  <img :src="rightArrow" />
                </div>
                <img class="bgImg" :src="sand.img" />
              </div>
            </div>
          </div>
          <!--     小圆点分页器       -->
          <div
            class="swiper-pagination-sand flex align-center justify-center"
            slot="pagination"
            style="width: 100%; height: 20px"
          ></div>
        </div>
      </div>
      <DidLink
        @click.native="linkMore('https://lab.huaweicloud.com/')"
      ></DidLink>
    </div>
  </div>
</template>

<script>
import Title from "./common/Title";
// import { swiper, swiperSlide } from "vue-awesome-swiper";
import { Swiper } from "vue-awesome-swiper";
var self;

export default {
  name: "Sandbox",
  data() {
    return {
      isLowIos: false,
      swiperOption: {},
      hoverIndex: 1,
      blueImg: require("../assets/images/sandbox/blueImg.png"),
      redImg: require("../assets/images/sandbox/redImg.png"),
      rightArrow: require("../assets/images/sandbox/rightArrow.png"),
      blueImgTop: require("../assets/images/sandbox/blueImgTop.png"),
      redImgTop: require("../assets/images/sandbox/redImgTop.png"),
      yellowImgTop: require("../assets/images/sandbox/yellowImgTop.png"),
      topImg: require("../assets/images/sandbox/topImg.png"),
      yellowImg: require("../assets/images/sandbox/yellowImg.png"),
      titleBgImg: require("../assets/images/wap/title/sandbox.png"),
      sandboxLists: [
        {
          title: "30分钟轻松搭建网站应用",
          desc: "快速入门云计算，利用云服务搭建WordPress网站。",
          img: require("../assets/images/wap/sandbox/blueBg.png"),
          url: "https://lab.huaweicloud.com/testdetail_236",
        },
        {
          title: "使用ModelArts实现花卉图像分类",
          desc: "零基础体验AI开发，快速构建花卉图像分类。",
          img: require("../assets/images/wap/sandbox/redBg.png"),
          url: "https://lab.huaweicloud.com/testdetail_287",
        },
        {
          title: "MySQL本地数据库迁移",
          desc: "通过DRS掌握迁移流程，实现迁移中不停机最小化中断时间。",
          img: require("../assets/images/wap/sandbox/yellowBg.png"),
          url: "https://lab.huaweicloud.com/testdetail_290",
        },
      ],
      swiper_sand: null,
    };
  },
  components: {
    Title,
    // swiper,
    // swiperSlide,
  },
  created() {
    const userAgent = navigator.userAgent.toLowerCase();
    const versions = userAgent.match(/(\d+)(_\d+_\d+)/);
    const isIphone =
      userAgent.indexOf("iphone") > 0 || userAgent.indexOf("mac") > 0;
    let version = "";
    if (versions && versions[0]) {
      version = parseInt(versions[0].match(/\d+/)[0]);
    }
    if (isIphone && version < 15) {
      this.isLowIos = true;
    }
    self = this;
    // this.swiperOption = {
    //   loop: true, //首尾循环
    //   slidesPerView: "auto",
    //   centeredSlides: true,
    //   pagination: {
    //     el: ".swiper-pagination-sand",
    //     clickable: true,
    //     bulletClass: "my-bullet",
    //     bulletActiveClass: "my-bullet-active2",
    //   },
    //   on: {
    //     click(e) {
    //       const realIndex = this.realIndex;
    //       window._hw("send", "action", "index_cloud_lab_click", {
    //         content_name: self.sandboxLists[realIndex].title, // 内容名称
    //         product_tag: "", //产品标签
    //         industry_tag: "", //行业标签
    //         solution_tag: "", //解决方案标签
    //         hw_relation: self.$store.state.userInfo.hwRelation, //与华为关系
    //       });
    //       window.open(self.sandboxLists[realIndex].url); // 新窗口打开外链接
    //     },
    //   },
    // };
  },
  mounted() {
    self = this;
    this.loadSwiper();
    this.$bus.$on("reSwiper", (res) => {
      //初始化 swiper 方法 ↓
      this.swiper_sand.init();
    });
  },

  methods: {
    // 查看更多
    linkMore(url) {
      window._hw("send", "action", "index_cloud_lab_click", {
        module_name: "查看更多-沙箱实验室",
      });
      window.open(url); // 新窗口打开外链接
    },
    toDetail(url, title) {
      if (!this.isLowIos) {
        this.linkDownload(url, title);
      }
    },
    linkDownload(url, ch) {
      window._hw("send", "action", "index_cloud_lab_click", {
        content_name: ch, // 内容名称
        product_tag: "", //产品标签
        industry_tag: "", //行业标签
        solution_tag: "", //解决方案标签
        hw_relation: this.$store.state.userInfo.hwRelation, //与华为关系
      });
      window.open(url); // 新窗口打开外链接
      //埋码 开发者大会首页-点击社区专题
    },
    loadSwiper() {
      this.swiper_sand = new Swiper(".swiper-container-sand", {
        loop: true, //首尾循环
        // centeredSlides: false,
        // slidesPerView: 1.19, //每组 有多少块
        // loopedSlides: 10,
        // spaceBetween: 18, //板块间隔
        // slidesPerGroup: 1, //多少个板块为1组。
        slidesPerView: "auto",
        centeredSlides: true,
        pagination: {
          el: ".swiper-pagination-sand",
          clickable: true,
          bulletClass: "my-bullet",
          bulletActiveClass: "my-bullet-active2",
        },
        on: {
          click(e) {
            //alert("点击了");
            const realIndex = this.realIndex;
            window._hw("send", "action", "index_cloud_lab_click", {
              content_name: self.sandboxLists[realIndex].title, // 内容名称
              product_tag: "", //产品标签
              industry_tag: "", //行业标签
              solution_tag: "", //解决方案标签
              hw_relation: self.$store.state.userInfo.hwRelation, //与华为关系
            });
            window.location.href = self.sandboxLists[realIndex].url;
            // window.open(self.sandboxLists[realIndex].url); // 新窗口打开外链接
          },
        },
      });
    },
  },
};
</script>
<style lang="scss" scoped>
#sandbox-pc {
  display: none;
}

#sandbox-wap {
  display: none;
}

@media screen and (max-width: 992px) {
  #sandbox-wap {
    display: block;
    width: 100%;
    padding-top: 143px;
    padding-bottom: 0px;

    .top {
      width: 100%;
    }

    .describe {
      margin: 0 auto;
      width: calc(100% - 70px);
      font-size: 24px;
      font-family: Microsoft YaHei-Light;
      font-weight: 400;

      color: #333333;
      line-height: 36px;
    }

    .list {
      margin: 0 auto;
      width: 100%;
      height: 418px;
      margin-top: 22px;
      overflow: hidden;

      ::v-deep .swiper-container-sand {
        position: relative;

        .swiper-slide {
          width: 80% !important;
          margin: 0 2%;
        }

        .swiper-slide-active {
          transition: 200ms;
          transform: scale(1) !important;
        }

        .swiper-slide-prev {
          right: -4%;
          transition: 200ms;
          transform: scale(0.9) !important;
        }

        .swiper-slide-next {
          left: -4%;
          transition: 200ms;
          transform: scale(0.9) !important;
        }

        .swiper-pagination-sand {
          width: 100%;
          position: absolute;
          bottom: 0;
          left: 0;
          z-index: 10;
        }

        .my-bullet {
          width: 26px;
          height: 8px;
          background: #c4c4c4;
          border-radius: 0px 0px 0px 0px;
          opacity: 1;
          margin: 0 5px;
        }

        .my-bullet-active2 {
          background: #b4251e;
        }
      }
      .slide {
        width: 50%;
        height: 100%;
        box-sizing: border-box;
        padding: 64px 40px 0 40px;
        position: relative;
        transform: translate3d(0, 0, 0);

        .title {
          width: 545px;
          height: 52px;
          font-size: 30px;
          font-family: Microsoft YaHei-Light;
          font-weight: 600;
          color: #151e26;
          line-height: 45px;
        }

        .desc {
          width: 390px;
          height: 59px;
          font-size: 24px;
          font-family: Microsoft YaHei-Light;
          font-weight: 400;

          color: #888888;
          line-height: 33px;
        }

        .more {
          width: 150px;
          height: 24px;
          margin-top: 98px;
          font-size: 24px;
          font-family: Microsoft YaHei-Light;
          font-weight: 400;

          color: #b4251e;
          line-height: 24px;

          img {
            margin-left: 5px;
            width: 28px;
            height: 10px;
          }
        }

        .bgImg {
          width: 100%;
          height: 100%;
          position: absolute;
          bottom: 0;
          right: 0;
          z-index: -1;
        }
      }
    }
  }
}

@media screen and (min-width: 992px) {
  #sandbox-pc {
    display: block;
    width: 100%;
    padding-top: 60px;
    padding-bottom: 60px;

    .top {
      width: 1600px;
      margin-left: 160px;
    }

    .describe1 {
      width: 1600px;
      font-size: 18px;
      margin-left: 160px;
      margin-bottom: 30px;
      font-family: Microsoft YaHei-Light;
      font-weight: 400;

      color: #333333;
    }

    .content {
      width: 1599px;
      margin-left: 162px;
      position: relative;

      .main {
        width: 1598px;
        height: 320px;
        position: relative;
        background: rgba(255, 255, 255, 0.45)
          linear-gradient(
            147deg,
            rgba(255, 255, 255, 0) 0%,
            rgba(255, 255, 255, 0.5),
            rgba(255, 255, 255, 0) 100%
          );
        border: 2px solid;
        border-image: linear-gradient(
            160deg,
            rgba(255, 255, 255, 1),
            rgba(235, 235, 235, 0),
            rgba(235, 235, 235, 0),
            rgba(255, 255, 255, 0.62)
          )
          2 2;
        filter: blur(undefinedpx);
        opacity: 1;

        .topImg {
          width: calc(100% + 4px);
          height: 6px;
          position: absolute;
          top: -3px;
          left: -2px;
        }

        .text {
          width: 100%;
          height: 100%;
          padding-top: 60px;
          padding-bottom: 60px;
          padding-left: 69px;

          .title {
            width: 545px;
            height: 82px;
            font-size: 34px;
            font-family: Microsoft YaHei-Light;
            font-weight: 600;
            color: #151e26;
            line-height: 51px;
          }

          .describe {
            width: 60%;
            height: 59px;
            font-size: 18px;
            font-family: Microsoft YaHei-Light;
            font-weight: 400;

            color: #888888;
            line-height: 24px;
          }

          .more {
            width: 117px;
            height: 24px;
            margin-top: 32px;
            font-size: $font-xxl;
            font-family: Microsoft YaHei-Light;
            font-weight: 400;

            color: #b4251e;
            line-height: 24px;

            img {
              margin-left: 5px;
              width: 28px;
              height: 12px;
            }
          }
        }

        .blueImg {
          width: 865px;
          height: 314px;
          position: absolute;
          right: 117px;
          bottom: 0;
        }
      }

      .secondary {
        width: 1599px;
        height: 410px;
        margin-top: 40px;

        .secondary_left {
          width: 780px;
          height: 410px;
          position: relative;
          //border: 1px solid #ffffff;
          background: rgba(255, 255, 255, 0.45)
            linear-gradient(
              147deg,
              rgba(255, 255, 255, 0) 0%,
              rgba(255, 255, 255, 0.5),
              rgba(255, 255, 255, 0) 100%
            );
          border: 2px solid;
          border-image: linear-gradient(
              160deg,
              rgba(255, 255, 255, 1),
              rgba(235, 235, 235, 0),
              rgba(235, 235, 235, 0),
              rgba(255, 255, 255, 0.62)
            )
            2 2;
          filter: blur(undefinedpx);
          opacity: 1;

          .topImg {
            width: 780px;
            height: 6px;
            position: absolute;
            top: -3px;
            left: -2px;
          }

          .text {
            width: 100%;
            height: 100%;
            padding-top: 75px;
            padding-bottom: 75px;
            padding-left: 70px;

            .title {
              height: 82px;
              font-size: 34px;
              font-family: Microsoft YaHei-Light;
              font-weight: 600;
              color: #151e26;
              line-height: 51px;
            }

            .describe_l {
              width: 60%;
              height: 59px;
              font-size: 18px;
              font-family: Microsoft YaHei-Light;
              font-weight: 400;

              color: #888888;
              line-height: 24px;
            }

            .more {
              width: 117px;
              height: 24px;
              margin-top: 95px;
              font-size: $font-xxl;
              font-family: Microsoft YaHei-Light;
              font-weight: 400;

              color: #b4251e;
              line-height: 24px;

              span {
                line-height: 1.7 !important;
              }

              img {
                margin-left: 5px;
                width: 28px;
                height: 12px;
              }
            }
          }

          .yellowImg {
            width: 366px;
            height: 267px;
            position: absolute;
            right: 10px;
            bottom: 0;
          }
        }

        .secondary_right {
          width: 780px;
          height: 410px;
          position: relative;
          background: rgba(255, 255, 255, 0.45)
            linear-gradient(
              147deg,
              rgba(255, 255, 255, 0) 0%,
              rgba(255, 255, 255, 0.5),
              rgba(255, 255, 255, 0) 100%
            );
          opacity: 1;
          border: 2px solid;
          border-image: linear-gradient(
              160deg,
              rgba(255, 255, 255, 1),
              rgba(235, 235, 235, 0),
              rgba(235, 235, 235, 0),
              rgba(255, 255, 255, 0.62)
            )
            2 2;
          filter: blur(undefinedpx);

          .topImg {
            width: 780px;
            height: 6px;
            position: absolute;
            top: -3px;
            left: -2px;
          }

          .text {
            width: 100%;
            height: 100%;
            padding-top: 75px;
            padding-bottom: 75px;
            padding-left: 70px;

            .title {
              width: 448px;
              height: 82px;
              font-size: 34px;
              font-family: Microsoft YaHei-Light;
              font-weight: 600;
              color: #151e26;
              line-height: 51px;
            }

            .describe_l {
              width: 60%;
              height: 59px;
              font-size: 18px;
              font-family: Microsoft YaHei-Light;
              font-weight: 400;

              color: #888888;
              line-height: 24px;
            }

            .more {
              width: 117px;
              height: 24px;
              margin-top: 95px;
              font-size: $font-xxl;
              font-family: Microsoft YaHei-Light;
              font-weight: 400;

              color: #b4251e;
              line-height: 24px;

              span {
                line-height: 1.7 !important;
              }

              img {
                margin-left: 5px;
                width: 28px;
                height: 12px;
              }
            }
          }

          .redImg {
            width: 445px;
            height: 298px;
            position: absolute;
            right: 0;
            bottom: 0;
          }
        }
      }
    }
  }
}
</style>
